import React, { useEffect, useState } from "react";
import "../../styles/studentProfile.css";
import ReusableChart from "../ReusableComponent/Chart";
import img from "../../assets/Noimg3.jpg";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import {
  students_profile,
  subscriptions_details,
} from "../../util/Apiendpoits";
import { getWithTokenAPI, putWithTokenAPI } from "../../util/Api";
import { useSelector } from "react-redux";
import { StudentProfileSkeleton } from "../ReusableComponent/TableSkeleton";
import { SafeToast } from "../Toast/ShowToast";
import { ChevronLeft } from "lucide-react";
const StudentProfile = () => {
  const [loading, setLoading] = useState(true);

  const [Scriptionsdetails, setScriptionsdetails] = useState();
  const [chartData, setChartData] = useState([]);
  const [courses, setCourses] = useState([]);
  const [profile, setProfile] = useState();
  const [approwsName, setApprowsName] = useState("");
  const [institutionName, setInstitutionName] = useState("");
  const { studentId, institutionId, batchId } = useParams();
  const { token, roleType, userId } = useSelector((state) => state.auth);
  const [Autoapprovedbtn, setAutoapprovedbtn] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const currentYear = new Date().getFullYear();
  const minYear = 2026;
  const maxYear = currentYear + 1;
  const navigate = useNavigate();
  const fetchstudentsProfile = async () => {
    try {
      const res = await getWithTokenAPI(
        token,
        `${students_profile}${studentId}`,
      );

      if (res?.statusCode === 200) {
        setProfile(res.data);
      }
    } catch (error) {
      console.error("Profile fetch error", error);
    }
  };

  const fetchsubscriptionsdetails = async () => {
    try {
      const res = await getWithTokenAPI(
        token,
        `${subscriptions_details}${studentId}&batchId=${batchId}&institutionId=${institutionId}`,
      );

      if (res?.success) {
        setScriptionsdetails(res.data?.subscriptions?.[0]);
        // const approvedByIds = res?.data?.subscriptions?.[0].);
        const Autoapprovedbtn = res?.data?.subscriptions?.[0]?.approvedByName;
        setAutoapprovedbtn(Autoapprovedbtn);

      }
    } catch (error) {
      console.error("Subscription fetch error", error);
    }
  };

  const fetchChartData = async () => {
    try {
      const res = await getWithTokenAPI(
        token,
        `/admin/dashboard/student/${studentId}/subscriptions?year=${selectedYear}&month=${selectedMonth}`,
      );

      const data = res?.data;
      setCourses(data.boughtCourses);

      // DAY-WISE (when month is selected)
      if (selectedMonth !== "" && Array.isArray(data?.days)) {
        setChartData(
          data.days.map((item) => ({
            x: item.day,
            count: item.totalSubscriptions,
          })),
        );
        return;
      }

      // MONTH-WISE (when month is NOT selected)
      if (selectedMonth === "" && Array.isArray(data?.graph)) {
        setChartData(
          data.graph.map((item) => ({
            x: item.month,
            count: item.totalSubscriptions,
          })),
        );
        return;
      }
      setChartData([]);
    } catch (error) {
      console.error("Chart fetch error:", error);
      setChartData([]);
    }
  };

  useEffect(() => {
    const loadAll = async () => {
      setLoading(true);
      await Promise.all([
        fetchstudentsProfile(),
        fetchsubscriptionsdetails(),
        fetchChartData(),
      ]);
      setLoading(false);
    };
    loadAll();
  }, [selectedMonth, selectedYear]);

  // Pagination logic for Bought Courses
  const totalPages = Math.ceil((courses?.length || 0) / rowsPerPage);
  const paginatedCourses = courses?.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage,
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [courses]);

  const handleBlock = async (isBlockedvalue) => {
    const payload = {
      is_block: isBlockedvalue,
    };

    const action = profile?.is_block ? "Unblocked" : "Blocked";

    try {
      const res = await putWithTokenAPI(
        token,
        `/user/update/${studentId}`,
        payload,
      );

      if (res?.statusCode == 200) {
        SafeToast.success(`Student ${action} successfully`);
        fetchstudentsProfile();
      } else {
        SafeToast.error(res?.message || "Failed to update student status");
      }

      return res;
    } catch (error) {
      console.error("Error updating student status:", error);
      SafeToast.error("Failed to update student status");
      throw error;
    }
  };

  const filters = {
    userTypes: [
      { value: "dealer", label: "Dealer" },
      { value: "consumer", label: "Consumer" },
      { value: "both", label: "Both" },
    ],
    months: [
      { value: "", label: "All Months" },
      { value: "01", label: "January" },
      { value: "02", label: "February" },
      { value: "03", label: "March" },
      { value: "04", label: "April" },
      { value: "05", label: "May" },
      { value: "06", label: "June" },
      { value: "07", label: "July" },
      { value: "08", label: "August" },
      { value: "09", label: "September" },
      { value: "10", label: "October" },
      { value: "11", label: "November" },
      { value: "12", label: "December" },
    ],
    years: [
      { value: "", label: "All Years" },
      ...Array.from({ length: maxYear - minYear + 1 }, (_, i) => {
        const year = maxYear - i; // descending order
        return {
          value: String(year),
          label: String(year),
        };
      }),
    ],
  };

  if (loading) {
    return <StudentProfileSkeleton />;
  }

  return (
    <div className="student-page">
      <div className="student-header-studentProfile">
        <div className="student-title-wrap-particlur">
          <h2 className="student-title-particlur">
            <button className="nav-btn" onClick={() => navigate("/students")}>
              <ChevronLeft size={18} />
            </button>
            Students
          </h2>

          <span className="student-name">
            {" "}
            <span className="student-arrow"></span> {profile?.name}
          </span>
        </div>
      </div>

      {/* PROFILE CARD */}
      <div className="student-card">
        {/* IMAGE */}
        <div className="student-image">
          <img src={profile?.profile_img || img} alt="student" />
        </div>

        {/* DETAILS */}
        <div className="student-info">
          <span
            className={`status-badge ${profile?.status ? "active" : "inactive"}`}
          >
            <span className="dot"></span>
            {profile?.status ? "Active" : "Non Active"}
          </span>

          <div className="status-container">
            <h3 className="name-row">{profile?.name}</h3>
          </div>
          <div className="info-row">
            <span className="label">Phone :</span>
            <span className="value">+91 {profile?.phoneNumber}</span>
          </div>

          <div className="info-row">
            <span className="label">Joined Date :</span>
            <span className="value">
              {profile?.createdAt
                ? new Date(profile.createdAt).toLocaleDateString("en-GB")
                : "-"}
            </span>
          </div>

          <button className="institution-btn">
            Institution :{" "}
            {Scriptionsdetails?.institution?.nameofInstitution || "NA"}
          </button>
          <button
            className={profile?.is_block ? "unblock-btn" : "block-btn"}
            onClick={() => handleBlock(!profile?.is_block)}
          >
            {profile?.is_block ? "Unblock" : "Block"}
          </button>
        </div>

        <div className="approved-requested-wrapper">
          {Scriptionsdetails?.isApproved ? (
            Autoapprovedbtn && (
              <span className="approved">
                Approved by : {Autoapprovedbtn || "NA"}
              </span>
            )
          ) : (
            <div className="requested-wrapper">
              <div className="requested-dropdown">
                Requested <span className="arrow-down">▼</span>
              </div>

              {/* The Receipt/Image Preview */}
              {Scriptionsdetails?.upload_img && (
                <div className="receipt-preview">
                  <img src={Scriptionsdetails?.upload_img} alt="Receipt" />
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <ReusableChart
        title="Student Details"
        filters={filters}
        rawData={chartData}
        selectedMonth={selectedMonth}
        selectedYear={selectedYear}
        setSelectedMonth={setSelectedMonth}
        setSelectedYear={setSelectedYear}
      />

      <div className="table-container">
        <h3>Bought Courses</h3>

        <table>
          <thead>
            <tr>
              <th>S. No</th>
              <th>Test Batch</th>
              <th>Institution</th>
            </tr>
          </thead>

          <tbody>
            {paginatedCourses?.length > 0 ? (
              paginatedCourses.map((course, index) => (
                <tr key={`${course.batchId}-${(currentPage - 1) * rowsPerPage + index}`}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{course.testBatchName}</td>
                  <td>{course.institutionName}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: "center" }}>
                  No courses found
                </td>
              </tr>
            )}
          </tbody>
          {totalPages > 1 && (
            <tfoot>
              <tr>
                <td colSpan="3">
                  <div className="approvalpagination">
                    {currentPage > 1 && (
                      <button
                        className="page-btn"
                        onClick={() => setCurrentPage((p) => p - 1)}
                      >
                        ‹
                      </button>
                    )}

                    {currentPage > 1 && (
                      <button
                        className="page-btn"
                        onClick={() => setCurrentPage(1)}
                      >
                        1
                      </button>
                    )}

                    {currentPage > 2 && <span className="page-dots">…</span>}

                    <button className="page-btn active">{currentPage}</button>

                    {currentPage < totalPages - 1 && (
                      <span className="page-dots">…</span>
                    )}

                    {currentPage !== totalPages && (
                      <button
                        className="page-btn"
                        onClick={() => setCurrentPage(totalPages)}
                      >
                        {totalPages}
                      </button>
                    )}

                    {currentPage < totalPages && (
                      <button
                        className="page-btn"
                        onClick={() => setCurrentPage((p) => p + 1)}
                      >
                        ›
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
};

export default StudentProfile;
